import { TEXT } from '../../../../helpers/text.constants';

export const FormErrorText = {
	errorMessage: TEXT.formErrorMessage,
	correctMarkedFields: TEXT.correctMarkedFields,
};
